import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propBoolField, propNumberField, propSimpleEnumField, propTextField } from "../../common/entityStoreForm";
import { propRequired, propLengthMax, propValueValidator, propValidValue, propInt, propMinValue } from "../../common/entityStoreValidators";
import { UseListStore } from "../../common/listStore";
import { customerFlagTypes, useCustomerFlags } from "../../common/enum";
import { CustomerStopCodeDto } from "./types";

export const CustomerStopCodeDialog = (props: {
    close: () => void;
    customerStopCode: CustomerStopCodeDto | null;
    useListStore: UseListStore<CustomerStopCodeDto>;
}) => {
    const [useStore] = useState(() => createEntityStore<CustomerStopCodeDto>({
        data: props.customerStopCode != null ? props.customerStopCode : {
            name: "",
            code: "",
            isActive: true,
        },
        path: "settings/customerStopCodes",
        fetchOnInit: false,
        id: props.customerStopCode?.id ?? null,
        getNewId: p => p.id!,
        onSaved() {
            props.close();
            useCustomerFlags.getState().uninit();
            props.useListStore.getState().fetch();
        },
    }));

    const { save, id, isSaveDisabled } = useStore(p => ({ save: p.save, id: p.entityId, isSaveDisabled: p.isSaveDisabled }));
    const codes = props.useListStore(p => p.items);

    useEffect(() => {
        useStore.getState().setPropValidators([
            propLengthMax("code", 1),
            propValueValidator("code", (p, e) => (p ?? "") !== "" && (
                codes.some(r => r.code === p && r.type === e.type && id !== r.id)
            ) && "Code must be unique."),

            propRequired("name"),
            propLengthMax("name", 100),

            propRequired("type"),

            propValidValue("id", "idFormatted"),
            propInt("id"),
            propRequired("id"),
            propMinValue("id", 1),
            propValueValidator("id", p => p != null && (
                codes.some(r => r.id === p && id !== r.id)
            ) && "Id must be unique."),
        ]);
    }, [codes, id, useStore]);

    return <>
        <DialogTitle>{id == null ? `New customer stop code` : `Edit customer stop code`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={6}>{propNumberField(useStore)("id", "idFormatted", "Id", { disabled: id != null })}</Grid>
                <Grid item xs={6}>{propTextField(useStore)("code", "Code")}</Grid>
                <Grid item xs={12}>{propTextField(useStore)("name", "Name")}</Grid>
                <Grid item xs={12}>{propBoolField(useStore)("isActive", "Active")}</Grid>
                <Grid item xs={12}>{propSimpleEnumField(useStore)("type", "Type", customerFlagTypes, { disabled: id != null })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};